<!-- サイドバナー -->
<template>
  <div v-if="kensyuBannerListData.length > 0">
    <p class="side_text1">研修</p>
    <ul class="side_banner1">
      <li
        v-for="(banner, index) in kensyuBannerListData"
        :key="banner.bannerName"
      >
        <a :href="banner.bannerUrl" target="_blank">
          <span class="banner1">
            <img
              :src="kensyuImageSources[index] + '?v=' + new Date().getTime()"
              :alt="banner.bannerName"
              @error="kensyuHandleImageError(index)"
            />
            <span v-if="kensyuImageError[index]" class="t1">{{
              banner.bannerName
            }}</span>
          </span>
          <span class="text1">{{ banner.bannerCaption }}</span>
        </a>
      </li>
    </ul>
  </div>

  <div v-if="loadToMasterBannerListData.length > 0">
    <hr v-if="kensyuBannerListData.length > 0" class="sep1" />
    <p class="side_text1">Load To Master</p>
    <ul class="side_banner1">
      <li
        v-for="(banner, index) in loadToMasterBannerListData"
        :key="banner.bannerName"
      >
        <a :href="banner.bannerUrl" target="_blank">
          <span class="banner1">
            <img
              :src="
                loadToMasterImageSources[index] + '?v=' + new Date().getTime()
              "
              :alt="banner.bannerName"
              @error="loadToMasterHandleImageError(index)"
            />
            <span v-if="loadToMasterImageError[index]" class="t1">{{
              banner.bannerName
            }}</span>
          </span>
          <span class="text1">{{ banner.bannerCaption }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { AxiosError } from "axios";
import apiAuthClient from "@/util/apiClientAuth";
import { outputDebugLogs, formatMessage, getTargetDate } from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";

interface Item {
  bannerName: string;
  bannerCaption: string;
  bannerUrl: string;
  bannerImgFileName: string;
}

export default defineComponent({
  name: "SkilupSideSliderComponent",
  setup() {
    const kensyuBannerListData = ref<Item[]>([]);
    const kensyuImageError = ref<boolean[]>([]);
    const kensyuImageSources = ref<string[]>([]);

    const loadToMasterBannerListData = ref<Item[]>([]);
    const loadToMasterImageError = ref<boolean[]>([]);
    const loadToMasterImageSources = ref<string[]>([]);

    const kensyuHandleImageError = (index: number) => {
      kensyuImageError.value[index] = true;
      kensyuImageSources.value[index] = "/WITH_AG_PORTAL/images/bana-base1.png";
    };

    const loadToMasterHandleImageError = (index: number) => {
      loadToMasterImageError.value[index] = true;
      loadToMasterImageSources.value[index] =
        "/WITH_AG_PORTAL/images/bana-base1.png";
    };

    onMounted(async () => {
      try {
        outputDebugLogs("研修バナー取得");

        // 研修バナーデータ取得API
        const response = await apiAuthClient.post("/api/Banner/getBannerList", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          bannerKbn: AppConstants.BANNER_KBN_SKILUP_KENSYU,
          targetDate: getTargetDate(""),
        });
        kensyuBannerListData.value = response.data.bannerListData;
        outputDebugLogs(
          "研修バナー取得成功 件数：" + kensyuBannerListData.value.length
        );

        kensyuImageError.value = new Array(
          kensyuBannerListData.value.length
        ).fill(false);
        kensyuImageSources.value = kensyuBannerListData.value.map(
          (banner) => `/WITH_AG_PORTAL/images/${banner.bannerImgFileName}`
        );
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "研修バナーデータの取得"));
      } finally {
        //何か入れるかも
      }

      try {
        outputDebugLogs("LoadToMasterバナー取得");

        // LoadToMasterバナーデータ取得API
        const response = await apiAuthClient.post("/api/Banner/getBannerList", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          bannerKbn: AppConstants.BANNER_KBN_LOAD_TO_MASTER,
          targetDate: getTargetDate(""),
        });
        loadToMasterBannerListData.value = response.data.bannerListData;
        outputDebugLogs(
          "LoadToMasterバナー取得成功 件数：" +
            loadToMasterBannerListData.value.length
        );

        loadToMasterImageError.value = new Array(
          loadToMasterBannerListData.value.length
        ).fill(false);
        loadToMasterImageSources.value = loadToMasterBannerListData.value.map(
          (banner) => `/WITH_AG_PORTAL/images/${banner.bannerImgFileName}`
        );
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(
          formatMessage(messages.ERR_SYS003, "LoadToMasterバナーデータの取得")
        );
      } finally {
        //何か入れるかも
      }
    });

    return {
      kensyuBannerListData,
      kensyuImageError,
      kensyuImageSources,
      kensyuHandleImageError,
      loadToMasterBannerListData,
      loadToMasterImageError,
      loadToMasterImageSources,
      loadToMasterHandleImageError,
    };
  },
});
</script>
